import React from 'react';
import { Link } from 'react-router-dom';
import { getWhatsAppUrl, getEmailUrl, getPhoneUrl } from '../utils/contact';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Our Products</h3>
          <ul>
            <li><a href={process.env.REACT_APP_DOSSIER_URL} target="_blank" rel="noopener noreferrer">Dossier Compiler</a></li>
            <li><a href={process.env.REACT_APP_SCHOOL_URL} target="_blank" rel="noopener noreferrer">School</a></li>
            <li><a href={process.env.REACT_APP_REGULATIONS_URL} target="_blank" rel="noopener noreferrer">Regulations Hub</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Contact</h3>
          <ul>
            <li><a href={getWhatsAppUrl('Hello ProgrammoCeuticals')}>WhatsApp</a></li>
            <li><a href={getPhoneUrl()}>+234 903 378 2254</a></li>
            <li><a href={getEmailUrl('General Inquiry')}>info@programmoceuticals.com</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Legal</h3>
          <ul>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {currentYear} ProgrammoCeuticals. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;